import styled from 'styled-components';
import {GlobalColors, GlobalFonts} from '../../globals';

export const ContDatatoggle = styled.div`
  width: 100%;
  height: auto;
  background: #FFFFFF;
  z-index: 4;
`

export const Row = styled.div`
  display: flex;
  gap: 22px;

  &:not(:last-child) {
    margin-bottom: 24px;
  }
`;

export const Column = styled.div`
  flex: 1 1 0;
  display: flex;
  align-items: center;
  vertical-align: middle;
  min-width: 0;
`;

export const ContentContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 54px;
  border-radius: 50px;
  padding: 0 22px;
  box-sizing: border-box;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #CEE1F8;
  }
`;

export const Icon = styled.div`
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;

  & > img {
    width: 22px;
    height: 22px;
    object-fit: contain;
  }
`;

export const Text = styled.div`
  font-family: ${GlobalFonts.fontBold};
  color: ${GlobalColors.colorPrimaryDark};
  font-size: 14px;
  text-align: left;

  @media(min-width: 1024px) and (max-width: 1407px){
    font-size: 14px;
  }
  @media(min-width: 1408px) and (max-width: 1919px){
    font-size: 15px;
  }
  @media(min-width: 1920px){
    font-size: 16px;
  }
`;
